import { Container } from "@mui/material";
import React from "react";

import OurCompany from "./OurCompany";
import OurFeatures from "./OurFeatures";
import WhyUs from "./WhyUs";

const AboutUs = () => {
  return (
    <Container
      sx={{
        marginBlock: "30px",
        "@media (min-width: 1200px)": {
          maxWidth: "1400px",
        },
      }}
    >
      <OurCompany />
      <WhyUs />
      <OurFeatures />
    </Container>
  );
};

export default AboutUs;
